import React, { useEffect, useState } from 'react';
import ajaxSchool from '../remote/ajaxSchool';

const SchoolPaymentContext = React.createContext();

export const SchoolPaymentConsumer = SchoolPaymentContext.Consumer;

export const SchoolPaymentProvider = (props) => {

    const [transactionListing, setTransactionListing] = useState(false);
    const [metaData, setMetaData] = useState(false);
    const [data, setData] = useState({"page":"1"})
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);



    useEffect(()=>{
       getSchoolPaymentTransactions();
    }, [data])

    useEffect(()=>{
        if(currentPage>1)
        {
            fetchMoreTrigger()
        }
    }, [currentPage])



    const getSchoolPaymentTransactions=async()=>{
        setLoading(true)
        setTransactionListing(false)
        const server_response = await ajaxSchool.fetchRecentPayments(data);
        setLoading(false)
        if(server_response.status==="OK"){
            setTransactionListing(server_response.details.list);
            setMetaData(server_response.details.meta);
        }else{
            setTransactionListing("404");
            setMetaData(false);
        }
    }

  


    const fetchMoreTrigger=()=>{
        const newData={
            ...data,
            "page":currentPage,
        }
        fetchMore(newData)
    }


    const fetchMore = async(newData) => {
        setLoading(true);

        const server_response = await ajaxSchool.fetchRecentPayments(newData);

        setLoading(false);
           

        if (server_response.status === "OK") {
            const incoming = Array.from(server_response.details.content.list);
            setTransactionListing(transactionListing.concat(incoming));
            setMetaData(server_response.details.content.meta);
        }
       
    }


    const goToNextPage=()=>{
        if(currentPage < metaData.total_pages){
            setCurrentPage(currentPage + 1);
        }
    }


    const resetData=()=>{
        setCurrentPage(1)
        setData({"page":"1"})
    }

    const filterData=(options)=>{
        setData({
            "date_from":options.dateFrom,
            "date_to":options.dateTo,
            "payment_reason":options.selectedValue,
            "page":"1",
            "plate_number":options.keyword
        })
        
    }



  
    return (
        <SchoolPaymentContext.Provider value={{
            transactionListing,
            metaData,
            loading,
            goToNextPage,
            setData,
            resetData,
            filterData,
            getSchoolPaymentTransactions
        }}
        >
            {props.children}
        </SchoolPaymentContext.Provider>
    );
}


export default SchoolPaymentContext;
